import { render, staticRenderFns } from "./productDetailOutstock.vue?vue&type=template&id=783c35fd&scoped=true"
import script from "./productDetailOutstock.vue?vue&type=script&lang=js"
export * from "./productDetailOutstock.vue?vue&type=script&lang=js"
import style0 from "./productDetailOutstock.vue?vue&type=style&index=0&id=783c35fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c35fd",
  null
  
)

export default component.exports